module.exports = __webpack_public_path__ + "img/icon-facebook-logo.ca367170.svg";